<template>
  <div>
    <hooper
      ref="hooper"
      v-if="renderComponent"
      id="hooper"
      style="height: 400px; max-width: 440px; margin: auto; "
      :infiniteScroll="loop"
      :centerMode="!loop"
      :vertical="true"
      :itemsToShow="withImages === true ? 1.5 : 3"
      @updated="resize"
    >
      <slide v-for="(option, index) in sortedOptions" :key="option.id">
        <roulette-card
          @cardSelected="cardSelected"
          :index="index + 1"
          :branch="option.branch != undefined ? option.branch : ''"
          :color="option.color"
          :colorTexto="option.color"
          :id="option.id"
          :colorFilterValues="option.colorFilterValues || None"
          :helpKey="option.helpKey"
          :numerated="numerated"
          :withImages="withImages"
          :type="type"
        />
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
import 'hooper/dist/hooper.css'
import RouletteCard from '@/components/on-board/RouletteCard.vue'
export default {
  components: { Hooper, Slide, RouletteCard, HooperNavigation },
  props: {
    options: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    numerated: {
      type: Boolean,
      default: true
    },
    withImages: {
      type: Boolean,
      default: true
    },
    loop: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    renderComponent: true
  }),
  computed: {
    sortedOptions: function() {
      let optionsCopy = this.options.filter(opt => !opt.rouletteHidden)
      return optionsCopy.sort(function(a, b) {
        return a.index - b.index
      })
    }
  },
  mounted() {
    let self = this
    window.onresize = function() {
      self.forceRerender()
      self.resize()
    }
  },
  methods: {
    forceRerender() {
      this.renderComponent = false
      this.$nextTick().then(() => {
        this.renderComponent = true
      })
    },
    cardSelected: function(option) {
      const id = option.id
      const branch = option.branch
      const actionMapper = {
        requester_company_types: 'SET_NEOFINTECH_REQUESTER_COMPANY_TYPES',
        economic_sectors: 'SET_NEOFINTECH_ECONOMIC_SECTORS',
        business_sectors: 'SET_NEOFINTECH_BUSINESS_SECTORS',
        capital_program_types: 'SET_NEOFINTECH_CAPITAL_PROGRAM_TYPES',
        fundraising_program_types: 'SET_NEOFINTECH_FUNDRAISING_PROGRAM_TYPES',
        program_currency_types: 'SET_NEOFINTECH_PROGRAM_CURRENCY_TYPES',
        requested_amount_ranges: 'SET_NEOFINTECH_REQUESTED_AMOUNT_RANGES',
        sells_amount_ranges: 'SET_NEOFINTECH_SELLS_AMOUNT_RANGES',
        ebidta_sign: 'SET_NEOFINTECH_EBIDTA_SIGN',
        ebidta_amount_ranges: 'SET_NEOFINTECH_EBIDTA_AMOUNT_RANGES',
        sells_prediction: 'SET_NEOFINTECH_SELLS_FORECAST',
        has_account_auditor: 'SET_NEOFINTECH_HAS_ACCOUNT_AUDITOR',
        program_beneficiaries: 'SET_NEOFINTECH_PROGRAM_BENEFICIARIES'
      }
      this.$store.commit('onBoard/' + actionMapper[this.type], [id])
      this.$router.push({ name: this.$route.meta.next + branch })
    },
    resize: function() {
      let topNavbarHeight = document.getElementById('top-navbar').clientHeight
      let bottomNavbarHeight = document.getElementById('bottom-navbar')
        .clientHeight

      let totalHeight =
        window.innerHeight - topNavbarHeight - bottomNavbarHeight

      let elem = document.getElementById('hooper')
      elem.style.height = totalHeight + 'px'
    }
  }
}
</script>

<style  lang="scss">
/*Alto contenedor cartas card container height
Father container determines the section height
Definir tamaño co contenedor pai
*/

#hooper {
  -webkit-overflow-scrolling: touch;
  max-height: 100%;
}

#hooper:focus {
  outline-width: 0 !important;
}

.hooper-list {
  margin: auto;
  width: 300px;
  padding: 0 30px;
  }

.hooper-navigation button {
  border: solid white;
  border-radius: 50%;
  fill: white;
  margin: 20px 0;
  background: radial-gradient(var(--rosa-eco), var(--rosa-dark-eco));
  transition: .4;
  line-height: .9em;
}
.hooper-slide {
  padding-top: 20px;
  max-height: 250px;
}
// Altura da fila contenedora slide
// Slide height

.card-content {
  cursor: pointer;
}
</style>
